import { Autocomplete, Box, FormControl, InputLabel, TextField, Typography } from "@mui/material"
import { AppContext } from "components/AppContextProvider"
import theme from "css/theme/light"
import { FC, useContext, useEffect, useRef, useState } from "react"
import { IFormCompanyProps } from "./formcompanypicker.interface"
import { useTranslation } from "react-i18next"
import { StyledFormLabel } from "shared/styled/Global"

const FormCompanyPicker: FC<IFormCompanyProps> = (props) => {
  const { id, labelKey, labelDefault, handleChange, value, optional } = props
  const [options, setOptions] = useState<Array<{ label: string; value: string }>>()
  const appContext = useContext(AppContext)
  const { t } = useTranslation()
  const hasPrefilled = useRef(false)

  useEffect(() => {
    const companies = appContext.appUser.customer.companies
    const allCompanies = companies.map((company: any) => ({
      label: company.name,
      value: company.id
    }))
    setOptions(allCompanies)
  }, [])

  useEffect(() => {
    const hasNotBeenPrefilled = !hasPrefilled.current
    const hasOptions = options && options.length > 0
    const isValueEmpty = value === null || value === undefined || value === ""
    const canHandleChange = handleChange !== undefined

    if (hasNotBeenPrefilled && hasOptions && isValueEmpty && canHandleChange) {
      const mainCompanyId = appContext.appUser?.app?.mainCompanyId
      let companyToSelect = null

      if (mainCompanyId) {
        companyToSelect = options.find((company) => company.value?.toString() === mainCompanyId.toString())
      }

      if (!companyToSelect && options.length > 0) {
        companyToSelect = options[0]
      }

      if (companyToSelect) {
        handleChange(companyToSelect.value)
        hasPrefilled.current = true
      }
    }
  }, [options, value, appContext.appUser?.app?.mainCompanyId, handleChange])

  return (
    <Box my={0.75}>
      <StyledFormLabel>
        <Typography variant="labelLarge" fontWeight={500}>
          {labelKey ? t(labelKey, labelDefault) : labelDefault} {!optional && "*"}
        </Typography>
      </StyledFormLabel>
      <FormControl fullWidth>
        <Autocomplete
          loading
          loadingText="Laddar..."
          sx={{ width: "100%", background: theme.palette.background.paper }}
          id={id?.toString()}
          options={options ? options : []}
          getOptionLabel={(option) => option?.label}
          onChange={(e, option) => handleChange && handleChange(option?.value)}
          includeInputInList
          value={
            options?.find(
              (i) =>
                i.value?.toString() === value?.toString() ||
                i.value?.toString() === JSON.parse(value)?.Id?.toString()
            ) || null
          }
          renderInput={(params) => <TextField {...params} name={id?.toString()} variant="outlined" />}
        />
      </FormControl>
    </Box>
  )
}

export default FormCompanyPicker
